import { EventType, PublicClientApplication } from "@azure/msal-browser";
import type { AuthenticationResult, EventMessage } from "@azure/msal-browser";
import { msalConfig } from "authConfig";

const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.enableAccountStorageEvents();

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});

// Await handleRedirectPromise before any consumer (MsalProvider, axios interceptor)
// uses the instance. Without this, msal-react processes the redirect hash lazily
// after MsalProvider mounts, racing the first silent SSO and producing a transient
// interaction_required error on initial load.
export const msalReady: Promise<PublicClientApplication> = msalInstance.handleRedirectPromise().then((result) => {
  if (result?.account) {
    msalInstance.setActiveAccount(result.account);
  } else {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0 && accounts[0]) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
  return msalInstance;
});

export default msalInstance;
